import React from 'react';
import { useCurrentBreakpointName } from 'react-socks';

const CalendarEvent = (props) => {
    let className = 'dlvr-calendar-event',
        icons = {
            queue: 'ds-icon icon-queue',
            scheduled: 'con ion-android-alarm-clock',
            everq: 'ds-icon icon-everqueue',
            echo: 'ds-icon icon-replay-queue',
            automated: 'icon ion-forward'
        },
        icon = null,
        sourceClass = '',
        { event, style } = props,
        { dlvrSrc } = event,
        eventElement = null,
        format = 'hh:mm a',
        // what each source is called in the calendar's filter
        kinds = {
            queue: 'queued',
            scheduled: 'scheduled',
            echo: 'repeat',
            everqueue: 'Everqueue',
            automated: 'direct'
        };

    if (useCurrentBreakpointName() === 'mobile') {
        format = 'hh:mm';
    }

    [icon, sourceClass] = props.getSourceIcon(dlvrSrc);

    if (sourceClass) {
        className += ` ${sourceClass}`;
    }

    let time = new moment(event.queuetime);
    if (time < moment()) {
        className += " history"
    }

    const clickHandler = (e) => {
        e.preventDefault();
            e.stopPropagation();
            let id = null;

            if (event.id > 0) {
                id = event.id;
            }

            props.showDrawer(true, id, new moment(event.queuetime).tz(props.timezone).startOf('day'));
    };

    return (
        <div onClick={clickHandler} onTouchEnd={clickHandler} role="button" aria-label={`${new moment(event.queuetime).tz(props.timezone).format('h:mm a')}, ${kinds[sourceClass]}`}>
            <div className={className}>
                <div className="icon-wrapper">
                    {icon}
                </div>
                <div className="time-label">
                    {new moment(event.queuetime).tz(props.timezone).format(format)}
                </div>
            </div>
        </div>
    )
};

export default CalendarEvent;
